import { dateFormatMap } from '@op/constants';
import { formatTime } from '../../render-helper';
import { momentTimeAAfterB } from '@op/utils/time';
import { DBO_TM } from '@op/utils/format';

function renderValue() {
  const utcMinusTime = DBO_TM.utc().format('YYYY-MM-DD HH:mm:ss');
  return (item: any, key: string) => {
    const time = item.time;
    if (momentTimeAAfterB(utcMinusTime, time)) {
      return item[key];
    }
    return '-';
  };
}

export default function steamRealtimeColumns(params: any) {
  const { date_type } = params;
  return [
    {
      renderHelper: [formatTime(dateFormatMap[date_type])],
      header: 'Date',
      render: 'time',
    },
    {
      header: 'All - This time period',
      render: 'new_all_reviews',
      renderHelper: [renderValue()],
    },
    {
      header: 'Positive - This time period',
      render: 'new_good_reviews',
      renderHelper: [renderValue()],
    },
    {
      header: 'Negitive - This time period',
      render: 'new_bad_reviews',
      renderHelper: [renderValue()],
    },
    {
      renderHelper: [formatTime(dateFormatMap[date_type])],
      header: 'This time period',
      render: 'old_time',
    },
    {
      header: 'All - The previous corresponding period',
      render: 'old_all_reviews',
    },
    {
      header: 'Positive - The previous corresponding period',
      render: 'old_good_reviews',
    },
    {
      header: 'Negitive - The previous corresponding period',
      render: 'old_bad_reviews',
    },
  ];
}
